import { all, takeLatest, put, select } from 'redux-saga/effects';
import { matchesType } from '../helper';
import {
  pricing as actions,
  businessModule as businessModuleActions,
  analytics as analyticsActions,
} from '../../../actions';
import { getBillingPricingDetails } from '../../../api/pricingApi';

function* getPricing(): any {
  try {
    const businessModuleId = yield select((state) => state.businessModule.id);
    const pricing = yield getBillingPricingDetails(businessModuleId);
    const businessModuleName = pricing?.businessModules[0]?.businessModuleKey || 'Standard';
    yield put(businessModuleActions.receiveName(businessModuleName));
    yield put(actions.receivePricing(pricing));
  } catch (e) {
    yield put(actions.getPricingFailure());
    yield put(analyticsActions.track('Error Occurred', {
      location: window.location.pathname,
      action: 'get pricing failed',
      name: 'get-pricing',
    }));
  }
}

function* pricing(): any {
  yield all([takeLatest(matchesType(actions.getPricing), getPricing)]);
}

export { pricing };
